// Klanttype (eigenaarsregel 11 september 2026): vier waarden, geen boolean.
//
//   'client'                getekende klant voor werving en selectie (RecruitCRM
//                           Delivery Companies bevat 'Signed Client').
//   'contracting'           getekende klant voor contracting en freelance. Een
//                           klant, maar een ander soort: eigen chip, eigen
//                           filterwaarde, eigen standaard-contracttype (uurtarief).
//                           Deze waarde komt nooit uit de import, alleen uit een
//                           handmatige zet door een director.
//   'prospect_contracting'  bedrijf dat freelancers inhuurt (Delivery Companies
//                           bevat 'FL Client', hoofdletterongevoelig). NIET
//                           getekend: een contracting-prospect. Dit vervangt de
//                           regel van 4 september, die 'FL Client' als getekende
//                           contracting-klant las. Geen van de 755 zo gemarkeerde
//                           bedrijven had contractafspraken staan.
//   'prospect'              al het andere, ook 'Perm Client', 'CLIENT' en leeg.
//
// Alleen 'client' en 'contracting' zijn getekend: elke poort die vroeger
// `= 'client'` las, leest isClientType / isClientSql. Wie het soort wil
// onderscheiden (chip, filter, contracttermen) vergelijkt met de losse waarde of
// gebruikt isContractingType voor de contracting-soort ongeacht getekend.
//
// Dit bestand is de enige plek voor de waarden, labels en SQL-fragmenten.
// De lees-expressie zelf (override wint over de mirror) blijft clientTypeExpr in
// lib/crm/candidate-sql.mjs; die is waarde-agnostisch.

export const CLIENT_TYPES = ['client', 'contracting', 'prospect_contracting', 'prospect'];
export const SIGNED_CLIENT_TYPES = ['client', 'contracting'];

// Volgorde voor een keuzemenu: van koud naar getekend.
export const CLIENT_TYPE_ORDER = ['prospect', 'prospect_contracting', 'client', 'contracting'];

export const CLIENT_TYPE_LABEL = {
  client: 'Klant',
  contracting: 'Klant contracting',
  prospect_contracting: 'Prospect contracting',
  prospect: 'Prospect',
};

// Onbekend of leeg wordt prospect: de app claimt nooit een klant die niemand
// getekend heeft.
export function normalizeClientType(v) {
  const s = String(v || '').trim().toLowerCase();
  return CLIENT_TYPES.includes(s) ? s : 'prospect';
}

export function isClientType(v) {
  return SIGNED_CLIENT_TYPES.includes(String(v || '').toLowerCase());
}

// De contracting-soort, getekend of niet. Voor styling en standaarden die over
// het soort werk gaan (uurtarief, freelance), niet voor een getekend-poort.
export function isContractingType(v) {
  const s = String(v || '').trim().toLowerCase();
  return s === 'contracting' || s === 'prospect_contracting';
}

export function clientTypeLabel(v) {
  return CLIENT_TYPE_LABEL[normalizeClientType(v)];
}

// De importregel. `tokens` zijn de losse waarden van het multiselect-veld
// Delivery Companies (RecruitCRM custom field 1). Signed wint van FL als een
// bedrijf beide draagt: de wervingsafspraken zijn dan de leidende. 'FL Client'
// levert een contracting-prospect, nooit een getekende klant.
export function clientTypeFromDelivery(tokens) {
  const list = (Array.isArray(tokens) ? tokens : String(tokens || '').split(','))
    .map((s) => String(s || '').trim()).filter(Boolean);
  if (list.some((t) => t === 'Signed Client')) return 'client';
  if (list.some((t) => /^fl client$/i.test(t))) return 'prospect_contracting';
  return 'prospect';
}

// SQL. `expr` is een kant-en-klare clientTypeExpr(...)-aanroep of kolom.
export const SIGNED_CLIENT_SQL_LIST = `('client', 'contracting')`;
export const isClientSql = (expr) => `(${expr} IN ${SIGNED_CLIENT_SQL_LIST})`;
export const notClientSql = (expr) => `(COALESCE(${expr}, '') NOT IN ${SIGNED_CLIENT_SQL_LIST})`;
